// extracted by mini-css-extract-plugin
module.exports = {"root":"AddToWishlistButton_root___mbfr","forceMount":"AddToWishlistButton_forceMount__5__BM"};